<div class="border border-[var(--border)] rounded-xl p-3 bg-[var(--surface)]">
  <p class="text-[11px] font-bold uppercase tracking-wide text-[var(--faint)] mb-2">{{ etiqueta }}</p>

  @if (preview()) {
    <div class="flex items-center gap-3">
      <button type="button" (click)="abrirAmpliada()" [attr.aria-label]="'Ver foto en grande — ' + etiqueta">
        <img [src]="preview()" [alt]="etiqueta" class="w-20 h-20 rounded-lg object-cover border border-[var(--border)]" />
      </button>
      <button type="button" (click)="repetirFoto()" class="text-[12.5px] font-semibold text-[var(--blue-ink)]">
        Repetir foto
      </button>
    </div>
  } @else {
    <label [for]="archivoInputId"
           class="w-full flex items-center justify-center gap-2 text-[13px] font-semibold py-2.5 rounded-lg border border-[var(--border)] cursor-pointer">
      📷 Tomar foto
    </label>
  }

  <input #inputArchivo [id]="archivoInputId" type="file" accept="image/*" capture="environment"
         (change)="alSeleccionarArchivo($event)" class="sr-only" />
</div>

@if (verAmpliada()) {
  <app-visor-imagen [url]="preview()!" [titulo]="etiqueta" (cerrar)="cerrarAmpliada()" />
}
